import { ethers } from 'ethers';

interface IProps {
  entryFee: string;
}

const DJackGameDiceStats: React.FC<IProps> = ({ entryFee }: IProps) => (
  <>
    <div className="prizeWrapper">
      <div className="prizeText">MAX DICE</div>
      <div className="prizeValue">6</div>
    </div>
    <div className="prizeWrapper">
      <div className="prizeText">ENTRY FEE</div>
      <div className="prizeValue">{`${ethers.utils.formatEther(
        entryFee
      )} BNB`}</div>
    </div>
    <div className="prizeWrapper">
      <div className="prizeText">POINT LIMIT</div>
      <div className="prizeValue">13</div>
    </div>
  </>
);

export default DJackGameDiceStats;
